import sdl from '@jds/react-generated-sdl/JDSButton';
import type { JDSButtonProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, ButtonProps } from '../logic';

const Component = (props: ButtonProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'primary',
    size = 'medium',
    state = 'normal',
    fullWidth = false,
    disabled = false,
    loading = false,
    ariaLabel = props.label?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { kind, size, state, fullWidth, disabled, loading, ariaLabel, ...rest },
    'JDSButton',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const Button = withLogic(Component) as React.ForwardRefExoticComponent<
  ButtonProps & React.RefAttributes<HTMLButtonElement>
> & { slotName?: string };

Button.displayName = 'Button';
Button.slotName = 'jds_button';

export { Button, type JDSButtonProps };
